module.exports = __webpack_public_path__ + "img/authe-3.1370694.jpg";